import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PageLoading from '../../../common/componentsV2/elements/PageLoading';
import {
  addBackOfficeQuoteToCart,
  loadBackOfficeQuotes,
  removeBackOfficeQuoteFromCart, resetProfessionQuotes,
} from '../../../features/backofficeResults/backofficeResultsActions';
import { Layout } from '../components/Layout/Layout';
import { ProfessionQuotesStyles } from './BackOfficeRcProfessionQuotes.styles';
import { EstimateContainer } from '../../../common/components/redesignComponents/common/Redesign.styles';
import {
  RiskButton, RiskButtonRemove, RiskCard, RiskContainer, SelectFirstNotice, SelectQuotePlaceholder,
} from '../../../common/components/redesignComponents/ResultPageComponents/v2/ResultSlotCard.styles';
import { ResultModal } from '../../../common/components/redesignComponents/ResultPageComponents/v2/ResultModal.styles';
import { AvvisoAlert } from '../../RcQuotes.styles';
import ProfessionRiskCard from '../../../common/components/redesignComponents/Cards/ProfessionRiskCard';
import ProfessionCard from '../../../common/components/redesignComponents/Cards/ProfessionCard';
import { confirmAlert } from '../../../common/utils/alerts';
import ProcessingQuoteSelectedProfession from '../../../common/components/redesignComponents/ResultPageComponents/ProcessingQuoteSelectedProfession';
import TutelaSelectedProfession from '../../../common/components/redesignComponents/ResultPageComponents/TutelaSelectedProfession';
import AragCard from '../../../common/components/redesignComponents/Cards/AragCard';
import { getQuoteTypes } from '../../../features/utilities/utilitiesActions';
import { V2FontImport } from '../../../common/formInputsV2/V2Fonts';
import ResultOverviewRow from '../../../common/components/redesignComponents/ResultPageComponents/v2/ResultOverviewRow';
import ProfessionSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/ProfessionSummaryCard';
import QuoteCostSummaryCard from '../../../common/components/redesignComponents/ResultPageComponents/v2/QuoteCostSummaryCard';

const docs = {
  1: 'questionario_hcc_ingegneri.pdf',
  2: 'questionario_hcc_architetto.pdf',
  3: 'questionario_hcc_avvocato.pdf',
  4: 'questionario_hcc_Commercialista.pdf',
  5: 'questionario_hcc_consulente_del_lavoro.pdf',
  6: 'questionario_hcc_agente_immobiliare.pdf',
  7: 'questionario_hcc_agenti_di_attivita_finanziaria.pdf',
  8: 'questionario_hcc_amministratore_condominio.pdf',
  9: 'questionario_hcc_geometri.pdf',
  10: 'questionario_hcc_mediatore_creditizi.pdf',
  11: 'questionario_hcc_periti.pdf',
  12: 'questionario_hcc_tributarista.pdf',
  13: '',
  14: 'questionario_hcc_ag_commercio.pdf',
  15: 'questionario_hcc_agronomi.pdf',
  16: 'questionario_hcc_societa_di_edp.pdf',
  17: 'questionario_hcc_chimichi.pdf',
  18: 'questionario_hcc_dpo.pdf',
  19: 'questionario_hcc_geologi.pdf',
  20: 'questionario_hcc_miscellaneous.pdf',
  21: 'questionario_hcc_miscellaneous_energetica.pdf',
  22: 'questionario_hcc_psicologo.pdf',
  23: 'questionario_hcc_revisore_legale_dei_conti.pdf',
  24: 'questionario_hcc_singolo_componente_mediazione.pdf',
  25: 'questionario_hcc_tecnologo_alimentare.pdf',
  26: 'questionario_hcc_conformita.pdf',
};

const set_informativi = {
  1: 'set_informativo_hcc_ingegneri.pdf',
  2: 'set_informativo_hcc_architetto.pdf',
  3: 'set_informativo_hcc_avvocato.pdf',
  4: 'set_informativo_hcc_Commercialista.pdf',
  5: 'set_informativo_hcc_consulente_del_lavoro.pdf',
  6: 'set_informativo_hcc_agente_immobiliare.pdf',
  7: 'set_informativo_hcc_agenti_di_attivita_finanziaria.pdf',
  8: 'set_informativo_hcc_amministratore_condominio.pdf',
  9: 'set_informativo_hcc_geometri.pdf',
  10: 'set_informativo_hcc_mediatore_creditizi.pdf',
  11: 'set_informativo_hcc_periti.pdf',
  12: 'set_informativo_hcc_tributarista.pdf',
  13: '',
  14: 'set_informativo_hcc_ag_commercio.pdf',
  15: 'set_informativo_hcc_agronomi.pdf',
  16: 'set_informativo_hcc_societa_di_edp.pdf',
  17: 'set_informativo_hcc_chimichi.pdf',
  18: 'set_informativo_hcc_dpo.pdf',
  19: 'set_informativo_hcc_geologi.pdf',
  20: 'set_informativo_hcc_miscellaneous.pdf',
  21: 'set_informativo_hcc_miscellaneous_energetica.pdf',
  22: 'set_informativo_hcc_psicologo.pdf',
  23: 'set_informativo_hcc_revisore_legale_dei_conti.pdf',
  24: '',
  // "24": "set_informativo_hcc_singolo_componente_mediazione.pdf",
  25: 'set_informativo_hcc_tecnologo_alimentare.pdf',
  26: 'set_informativo_hcc_conformita.pdf',
};

const selectableExtensions = [
  'tlb',
  'tls',
  'tlg',
];

export default function BackofficeRcProfessionQuotes() {
  const { requestToken } = useParams();

  const state = useSelector((store) => store.backofficeResults.back_office_quotes);
  const {
    loading,
    requestInfo,
    quotes,
    processingQuote,
    addingQuote,
    customer,
    risk_quotations,

  } = state;

  const { quoteTypes } = useSelector((store) => store.utilities.quoteTypes);

  const [openModal, setOpenModal] = useState(false);

  const refresh = () => loadBackOfficeQuotes(requestToken);

  useEffect(() => {
    loadBackOfficeQuotes(requestToken);
    getQuoteTypes();

    return () => {
      resetProfessionQuotes();
    };
  }, []);

  const fetchQuotes = () => {
    loadBackOfficeQuotes(requestToken);
  };

  const selectQuotation = (quoteId) => {
    confirmAlert('Sei Sicuro di aggiungere questa quotazione?', () => addBackOfficeQuoteToCart(quoteId, fetchQuotes));
  };

  const removeItemFromCart = (quoteId) => {
    confirmAlert('Sei Sicuro di rimuovere questa quotazione?', () => removeBackOfficeQuoteFromCart(quoteId, fetchQuotes));
  };

  const getTotal = () => {
    let quoteInProccessAmount = 0;
    let risksTotalAmount = 0;

    if (processingQuote !== null && processingQuote.amount !== null) {
      quoteInProccessAmount = parseFloat(processingQuote.amount);
    }
    const riskTypes = quoteTypes.filter((t) => t.id !== 'res_civile');

    for (let x = 0; x < riskTypes.length; x++) {
      const type = riskTypes[x];
      if (risk_quotations && risk_quotations[type.id] !== undefined) {
        for (let i = 0; i < risk_quotations[type.id].length; i++) {
          const item = risk_quotations[type.id][i];

          risksTotalAmount += parseFloat(item.amount);
        }
      }
    }

    const total = quoteInProccessAmount + risksTotalAmount;
    return total.toFixed(2);
  };

  if (loading) {
    return <PageLoading />;
  }

  return (
    <Layout>
      {/* {openModal && <GuaranteesModalProfession setOpenModal={setOpenModal} profession={profession} extensions={extensions} requestToken={requestToken} selectableExtensions={selectableExtensions} />} */}
      <V2FontImport />
      <ProfessionQuotesStyles>
        <div className="resultsPage">
          <ResultOverviewRow>
            <ProfessionSummaryCard
              insuranceRequest={requestInfo}
              customer={customer}
            />
            <QuoteCostSummaryCard
              processingQuote={processingQuote}
              quoteTypes={quoteTypes}
              riskQuotations={risk_quotations}
              getTotal={getTotal}
            />
          </ResultOverviewRow>
          <div className="row">
            <div className="col-12">
              <EstimateContainer>
                {/* <h4>
                  Preventivi assicurazione
                  {' '}
                  <b>professionale</b>
                </h4>
                <p>
                  Inizio Copertura:
                  {' '}
                  {new Date(requestInfo.policy_effective_date).toLocaleDateString('it-IT', { year: 'numeric', month: 'numeric', day: 'numeric' })}
                </p> */}
              </EstimateContainer>
            </div>
          </div>

          {quotes && !quotes.res_civile
            && (
              <AvvisoAlert role="alert">
                <h4>Avviso!</h4>
                <p>Il preventivo non è riuscito per problemi relativi ai dati assicurativi. Si prega di contattare il nostro backoffice per ottenere il preventivo o ulteriori informazioni.</p>
              </AvvisoAlert>
            )}

          {quotes && quotes.res_civile && (
            <RiskContainer className="mb-4 result-profession-fourth-step">
              {quoteTypes.filter((t) => {
                if (processingQuote !== null && processingQuote.company_id === 1002) {
                  return t.id !== 'tutela_legale';
                }

                if (processingQuote !== null && processingQuote.company_id === 4) {
                  return t.id === 'tutela_legale' || t.id === 'res_civile';
                }

                return t;
              }).map((type, index) => (
                <React.Fragment key={index}>
                  {quotes && quotes[type.id] && (
                    <RiskCard className={`mt-3 purchase-quote-fourth-step flex-grow-1 d-flex align-items-center justify-content-between flex-column p-3 ${requestInfo.processing_quotation_id === null && type.id !== 'res_civile' ? 'bg-secondary bg-opacity-25' : ''} ${requestInfo.processing_quotation_id !== null && type.id === 'res_civile' ? 'bg-success bg-opacity-25' : ''} ${(risk_quotations && risk_quotations[type.id] !== undefined) ? 'bg-success bg-opacity-25' : ''}`}>
                      <div className="me-auto">
                        <h5>{type.name}</h5>
                      </div>
                      {(processingQuote !== null && type.id === 'res_civile')
                        && (
                          <ProcessingQuoteSelectedProfession
                            processingQuote={processingQuote}
                            requestInfo={requestInfo}
                            refresh={refresh}
                            profession={requestInfo.profession}
                            set_informativi={set_informativi}
                            requestToken={requestToken}
                            selectableExtensions={selectableExtensions}
                            docs={docs}
                          />
                        )}

                      {risk_quotations
                        && risk_quotations[type.id] !== undefined
                        && risk_quotations[type.id].map((quote, idx) => (
                          <React.Fragment key={idx}>
                            {processingQuote !== null
                              && processingQuote.company_id !== 2
                              && type.id === quote.quote_type && (
                                <TutelaSelectedProfession tutelaLegaleQuote={quote} type={type} />
                            )}
                          </React.Fragment>
                        ))}

                      {risk_quotations
                        && risk_quotations[type.id] === undefined
                        && type.id !== 'res_civile'
                        && processingQuote !== null && (
                          <SelectQuotePlaceholder
                            data-bs-toggle="modal"
                            data-bs-target={`#${type.id}`}
                          >
                            Seleziona Quotazione!
                          </SelectQuotePlaceholder>
                      )}

                      <div className="d-flex justify-content-end ms-auto gap-2">
                        {risk_quotations
                          && risk_quotations[type.id] !== undefined
                          && type.id !== 'res_civile'
                          && risk_quotations[type.id].map((quote, idx) => (
                            <React.Fragment key={idx}>
                              {type.id === quote.quote_type && (
                                <RiskButtonRemove
                                  className="btn btn-danger"
                                  onClick={() => removeItemFromCart(quote.id)}
                                >
                                  Rimuovi
                                </RiskButtonRemove>
                              )}
                            </React.Fragment>
                          ))}

                        {risk_quotations
                          && risk_quotations[type.id] === undefined
                          && processingQuote !== null
                          && type.id !== 'res_civile' && (
                            <RiskButton
                              className="btn btn-success"
                              data-bs-toggle="modal"
                              data-bs-target={`#${type.id}`}
                            >
                              Aggiungi
                            </RiskButton>
                        )}

                        {(type.id === 'res_civile' && processingQuote !== null) && <RiskButtonRemove className="btn btn-danger" onClick={() => removeItemFromCart(processingQuote.id)}>Rimuovi</RiskButtonRemove>}

                        {requestInfo.processing_quotation_id === null && type.id !== 'res_civile' && <SelectFirstNotice>Seleziona Prima La Responsibilita Civile</SelectFirstNotice>}

                        {type.id === 'res_civile' && <RiskButton className="btn btn-success" data-bs-toggle="modal" data-bs-target={`#${type.id}`}>Aggiungi</RiskButton>}
                      </div>
                    </RiskCard>
                  )}
                </React.Fragment>
              ))}
            </RiskContainer>
          )}
        </div>
        {quoteTypes.map((type, index) => (
          <ResultModal className="modal fade" id={type.id} tabIndex="-1" aria-labelledby={type.name} aria-hidden="true" key={index}>
            <div className="modal-dialog modal-dialog-centered">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id={type.name}>{type.name}</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" id="buttonClose" />
                </div>
                <div className="modal-body">
                  {addingQuote && (
                    <div className="d-flex align-items-center justify-content-between flex-column">
                      <div className="d-flex justify-content-center">
                        <div className="spinner-border" role="status">
                          <span className="visually-hidden">Aggiungendo...</span>
                        </div>
                      </div>
                      <div className="ms-2">Aggiungendo...</div>
                    </div>
                  )}
                  {addingQuote === false && quotes[type.id] ? quotes[type.id].map((quote, index) => (
                    <div className="mt-3" key={index}>
                      {quote.quote_type === 'res_civile'
                        ? (
                          <ProfessionCard
                            setOpenModal={setOpenModal}
                            requestInfo={requestInfo}
                            set_informativi={set_informativi}
                            docs={docs}
                            revealModal={openModal}
                            extensions={requestInfo.profession.extensions}
                            requestToken={requestToken}
                            selectableExtensions={selectableExtensions}
                            profession={requestInfo.profession}
                            quoteId={quote.id}
                            refresh={refresh}
                            selectQuotation={selectQuotation}
                            userData={quote}
                          />
                        )
                        : quote.company_id === 15
                          ? (
                            <AragCard
                              quotation={quote}
                              requestInfo={requestInfo}
                              type={type}
                              selectQuotation={selectQuotation}
                            />
                          )
                          : (
                            <ProfessionRiskCard
                              quote={quote}
                              requestInfo={requestInfo}
                              selectQuotation={selectQuotation}
                              professionId={requestInfo.profession.id}
                              type={type}
                              profession={requestInfo.profession}
                            />
                          )}
                    </div>
                  )) : addingQuote === false && (
                    <p>
                      Nessuna Quotazione
                      {type.name}
                      {' '}
                      Trovata.
                    </p>
                  )}
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-danger px-4" data-bs-dismiss="modal">Chiudi</button>
                </div>
              </div>
            </div>
          </ResultModal>
        ))}
      </ProfessionQuotesStyles>
    </Layout>
  );
}
